import DefaultThumbnail from "components/atoms/image/DefaultThumbnail";
import styled from "styled-components";
import { COLORS, LIGHT_THEME_COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import * as mediaQuery from "components/MediaQuery";

export const Container = styled.section<{ isEmpty?: boolean }>`
  width: 100%;
  background-color: ${({ theme, isEmpty }) =>
    isEmpty
      ? "transparent"
      : theme.value === "light"
      ? theme.COLORS.PRIMARY3
      : "#0c1724"};
  padding: 20px 30px;
  border-radius: 3px;
  flex: 1;

  ${mediaQuery.isMobile} {
    padding: 10px;

    > ul {
      width: 100%;
    }
  }
`;

export const NotifyAutoUpdateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE}90;
  font-size: ${calcRem(16)};
  max-width: 550px;
  margin: 0 auto;
  line-height: 1.35;
`;

export const Header = styled.div`
  ${FLEX.FlexBetweenCenter};
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  padding: 10px 15px;
  border-radius: 3px;
  margin-bottom: 20px;
  ${mediaQuery.isTablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`;

export const HeaderInfo = styled.div`
  ${FLEX.FlexBetweenCenter};

  ${mediaQuery.isDesktop} {
    justify-content: flex-start;
    gap: 40px;
  }
  ${mediaQuery.isMobile} {
    width: 100%;

    * {
      font-size: ${calcRem(13)};
    }
  }
`;

export const CvvLabel = styled.span`
  padding: 6px 10px;
  background-color: #ff001d;
  border-radius: 3px;
  font-weight: 500;
  ${FLEX.FlexCenterCenter};
  gap: 4px;
  font-size: ${calcRem(14)};

  img {
    width: 14px;
  }
`;

export const ContentHeader = styled.div`
  ${FLEX.FlexBetweenCenter};
  padding-bottom: 30px;

  ul {
    flex: 1;
  }
  li:last-of-type div + div {
    white-space: normal;
  }
  ${mediaQuery.isTablet} {
    flex-direction: column;
    gap: 10px;
    ul {
      width: 100%;
    }
    li {
      width: 100%;
    }
    p {
      align-items: flex-end;
      width: 100%;
    }
  }
`;

export const HeaderMessageWrapper = styled.div`
  ${FLEX.FlexStartStart};
  padding-bottom: 20px;
  gap: 6px;
  flex-direction: column;

  > span {
    ${FLEX.FlexStartCenter};
    gap: 4px;
    color: ${LIGHT_THEME_COLORS.BUTTONS2};
    font-size: ${calcRem(14)};
  }
`;

export const ContentInfo = styled.ul`
  flex: 1;
  ${FLEX.FlexStartCenter};
  gap: 60px;

  ${mediaQuery.isTablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    li:last-child {
      grid-column: 1 / 3;
    }
  }

  ${mediaQuery.isMobile} {
    ${FLEX.FlexBetweenCenter};
    width: 100%;
    justify-content: flex-start;
    gap: 10%;
  }
`;
export const ContentInfoItem = styled.li`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 8px;

  .content-info-item-title {
    font-weight: 400;
    color: ${({ theme }) => `${theme.COLORS.WHITE}90`};
  }
  strong {
    color: ${COLORS.RED};
  }
  ${mediaQuery.isMobile} {
    flex: 1;
    gap: 4px;

    * {
      font-size: ${calcRem(15)};
    }
  }
`;

/**
 * Camera ----
 */

export const CameraContainer = styled.ul``;

export const CameraHeaderItem = styled(ContentInfoItem)`
  width: 100%;
  flex: 1;
  max-width: 100%;
  overflow: hidden;

  > div {
    width: 100%;
    max-width: 100%;
    white-space: normal;
  }

  ${mediaQuery.isMobile} {
    gap: 10px;
    flex-direction: row;
  }

  .cvv-header-title {
    color: ${({ theme }) => `${theme.COLORS.WHITE}94`};
  }
`;

export const CameraItem = styled.li`
  width: 100%;
  margin-bottom: 30px;
`;

export const CameraTitle = styled.div`
  margin-bottom: 10px;

  .cvv-label {
    margin-left: 8px;
  }
`;

export const CameraWrapper = styled.ul`
  ${FLEX.FlexBetweenStart};
  gap: 18px;
  flex: 1;
  width: 100%;
  height: 100%;
  ${mediaQuery.isTablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  ${mediaQuery.isMobile} {
    flex-direction: column;
    display: flex;
  }
`;

export const CameraThumbnail = styled.li`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  flex: 1;
  height: 100%;
  width: 25%;
  cursor: pointer;
  gap: 10px;

  > div {
    width: 100%;
  }
  ${mediaQuery.isTablet} {
    width: auto;
  }
  ${mediaQuery.isMobile} {
    width: 100%;
  }
`;

export const CvvThumbnailWrapper = styled.div`
  position: relative;
`;
export const ThumbnailImage = styled(DefaultThumbnail)``;

export const ErrorBorder = styled.div`
  box-shadow: 0 0 0 2px ${COLORS.RED} inset;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 55;
`;

export const ErrorWrapper = styled.div`
  ${FLEX.FlexEndCenter};
  gap: 6px;
  position: absolute;
  z-index: 33;
  right: 6px;
  top: 6px;
`;

/**
 * CVV Modal
 */
export const ModalHeader = styled.div`
  width: 100%;
  position: relative;
  margin-top: -15px;

  button {
    position: absolute;
    top: -10px;
    right: 0;
  }

  ${mediaQuery.isMobile} {
    > button {
      right: 0;
      width: 22px;
    }
    > button img {
      width: 100%;
    }
  }
`;

export const ModalInfo = styled.ul`
  ${FLEX.FlexStartCenter};
  gap: 20px;

  ${mediaQuery.isMobile} {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
`;

export const CvvContainer = styled.section<{ isError: boolean }>`
  width: 100%;
  border-radius: 9px;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: -10px;

  ${({ isError }) =>
    isError &&
    `  
    border: 6px solid #ff001d;
  `}
`;

export const CvvHeader = styled.div`
  padding: 14px 6px;
  background-color: #ff001d;
  color: ${({ theme }) => theme.COLORS.WHITE};
  ${FLEX.FlexStartCenter};
  gap: 8px;

  img {
    width: 24px;
  }
`;

export const CvvImage = styled.img`
  width: 100%;
  height: 100%;
  background-size: cover;
`;

export const HeaderRight = styled.div`
  ${FLEX.FlexEndCenter};
  flex: 1;
  gap: 10px;

  .select-wrapper {
    width: 180px;
  }
  .search-input {
    width: 250px;
  }
  ${mediaQuery.isTablet} {
    .select-wrapper,
    .search-input {
      width: 100%;
    }
  }

  ${mediaQuery.isMobile} {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 10px;

    .select-wrapper {
      width: 50%;
    }
  }
`;
